// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_sg-0";